import { render, staticRenderFns } from "./DeadlinesFullCalendar.vue?vue&type=template&id=7689d197&scoped=true"
import script from "./DeadlinesFullCalendar.vue?vue&type=script&lang=js"
export * from "./DeadlinesFullCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7689d197",
  null
  
)

export default component.exports